import { GetFilterInput } from '@deltek/specification-client/core/Models/projectItem'
import React from 'react'

export interface ProjectFilterContextInterface {
    projectFilterValues: Partial<GetFilterInput>[]
    setProjectFilterValues: (value: Partial<GetFilterInput>[]) => void
}

export const ProjectFilterContext = React.createContext(
    {} as ProjectFilterContextInterface
)
